var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertTriangleM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0005 7V14H13.0005V7H11.0005Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0005 15C12.6908 15 13.2505 15.5596 13.2505 16.25C13.2505 16.9404 12.6908 17.5 12.0005 17.5C11.3101 17.5 10.7505 16.9404 10.7505 16.25C10.7505 15.5596 11.3101 15 12.0005 15Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7552 2.48704C12.9688 1.17098 11.0321 1.17099 10.2457 2.48704L1.28222 17.487C0.454502 18.8722 1.52502 20.5 3.03698 20.5H20.9639C22.4758 20.5 23.5464 18.8722 22.7186 17.487L13.7552 2.48704ZM11.9625 3.51296C11.9638 3.51074 11.9648 3.50948 11.9652 3.50892L11.966 3.50806L11.9683 3.50656C11.9728 3.50416 11.984 3.5 12.0004 3.5C12.0169 3.5 12.0281 3.50416 12.0325 3.50656L12.0344 3.50768L12.0356 3.50892C12.0361 3.50948 12.037 3.51074 12.0384 3.51296L20.9916 18.4958C20.9902 18.4964 20.9886 18.497 20.9865 18.4976C20.983 18.4985 20.9758 18.5 20.9639 18.5H3.03698C3.02504 18.5 3.0179 18.4985 3.01438 18.4976C3.01228 18.497 3.01062 18.4964 3.0093 18.4958L11.9625 3.51296Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertTriangleM);
export default __webpack_public_path__ + "static/media/alert-triangle-M.fb79d9b121fde3929623daf54b2da005.svg";
export { ForwardRef as ReactComponent };